export const queryKeys = {
  DUPLICATE_CONTROL: 'DUPLICATE_CONTROL'
};
